import { useCallback, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Warning as WarningIcon } from '@frontierag/frontier-ui-library/icons';
import { Badge, Box, TabsContainer } from '@frontierag/frontier-ui-library';
import { useField } from 'formik';

import AddProduct from './AddProduct';
import ViewBasket from './ViewBasket';

export default function OrderProducts() {
  const { t } = useTranslation('CreateOrder');
  const tabsRef = useRef<HTMLDivElement>(null);

  const [{ value: products = [] }, { error }] = useField('products');
  const productsCount = products.length;

  const viewBasketLabel = useMemo(() => {
    let tabLabel = <>{t('tabs.viewBasket')}</>;

    if (error && Array.isArray(error)) {
      tabLabel = (
        <>
          <WarningIcon color="warning" sx={{ fontSize: 16, mr: 1 }} />
          {t('tabs.viewBasket')}
        </>
      );
    }

    return productsCount > 0 ? (
      <Box alignItems="center" display="flex">
        {tabLabel}
        <Badge
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          badgeContent={productsCount}
          color="error"
          data-testid="view-basket-badge"
          sx={{ pl: 1, '& .MuiBadge-badge': { position: 'relative', transform: 'none' } }}
        />
      </Box>
    ) : (
      tabLabel
    );
  }, [productsCount, t, error]);

  const scrollTop = useCallback(() => {
    setTimeout(() => tabsRef?.current?.scrollIntoView({ block: 'start' }), 100);
  }, []);

  return (
    <Box ref={tabsRef} data-testid="order-products">
      <TabsContainer sx={{ pb: 5 }}>
        <TabsContainer.Panel name="add-product" label={t('tabs.addProduct')} key={0}>
          <AddProduct scrollTop={scrollTop} />
        </TabsContainer.Panel>
        <TabsContainer.Panel name="view-basket" key={1} label={viewBasketLabel}>
          <ViewBasket />
        </TabsContainer.Panel>
      </TabsContainer>
    </Box>
  );
}
